<template>
    <div>
        <Form ref="resourceApplicationForm" :model="resourceApplicationForm" :rules="ruleValidate" :label-width="140">
            <!-- 基本信息 -->
            <Row style="margin-bottom: 10px;">
                <Card>
                    <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t('resourceLifecycle.searchResource')}}</p>
                    <Row style="margin-bottom: 10px;">
                        <Col span="5" style="margin-right: 10px;">
                            <Input search v-model="resourceApplicationForm.usageNote" :placeholder="$t('resourceLifecycle.queryByPurpose')" @on-search="searchLifecycleResourcesDate()"/>
                        </Col>
                        <Col span="5" style="margin-right: 10px;">
                            <Input search v-model="resourceApplicationForm.resourceName" :placeholder="$t('resourceLifecycle.queryByResourceName')" @on-search="searchLifecycleResourcesDate()"/>
                        </Col>
                        <Col span="5" style="margin-right: 10px;">
                            <Select v-model="resourceApplicationForm.resourceType" filterable :placeholder="$t('resourceLifecycle.filterByResourceType')" :transfer="true" @on-change="searchLifecycleResourcesDate()">
                                <Option :value="item.id" v-for="item in resourceTypeList" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </Col>
                    </Row>
                    <Row :gutter="10" style="margin-bottom: 10px;">
                        <Table :no-data-text="$t('common.noData')" :columns="columns" :data="lifecycleResourcesDate"></Table>
                    </Row>
                </Card>
            </Row>

            <!-- 资源配置 -->
            <Row :gutter="10" style="margin-bottom: 10px;">
                <Col span="24">
                    <Card>
                        <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t('resourceLifecycle.resourceAllocation')}}</p>
                        <Row :gutter="10" style="margin-bottom: 10px;">
                            <Col span="11">
                                <FormItem :label="$t('resourceLifecycle.process')" prop="approvalFlow">
                                    <Select v-model="resourceApplicationForm.approvalFlow" filterable>
                                        <Option :value="item.id" v-for="(item,index) in approvalFlowList" v-bind:key="item.id">{{item.name}}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="22">
                                <FormItem :label="$t('resourceLifecycle.resourceReturnOrRecycleReason')" prop="describe">
                                    <Input v-model="resourceApplicationForm.describe" type="textarea" :autosize="{minRows: 2,maxRows: 10}"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="22">
                                <FormItem :label="$t('resourceLifecycle.attachment')" prop="enclosure">
                                    <Upload ref="upload" v-model="resourceApplicationForm.enclosure" :on-success="uploadSuccess" :on-error="uploadError" :headers='{"userName": userName}' multiple type="drag" :action="actionUrl" :show-upload-list="true" :on-remove="handleRemove">
                                        <div>
                                            <Icon type="ios-cloud-upload" size="50" style="color: #3399ff"></Icon>
                                            <p>{{$t('resourceLifecycle.clickOrDragFileHere')}}</p>
                                        </div>
                                    </Upload>
                                </FormItem>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
            <FormItem style="float: right;">
                <!-- 提交 -->
                <Button type="primary" :loading="addLoading" @click="handleSubmit(resourceApplicationForm)">{{$t('resourceLifecycle.submit')}}</Button>
            </FormItem>
        </Form>
    </div>
</template>

<script>
    import {setCookie, getCookie, delCookie} from '../../../utils/cookieUtil.js'
    import AmazonVirtualMachine from '../resource_change/aws/virtual_machine/AmazonVirtualMachine'
    import AzureVirtualMachine from '../resource_change/azure/virtual_machine/AzureVirtualMachine'

    export default {
        name: 'ResourceBasicInformationSearch',
        components: {
            AmazonVirtualMachine,
            AzureVirtualMachine
        },
    data() {
        return {
            company: getCookie(global.companyId),
            resourceTypeList: [{
                id: 0,
                name: this.$t("resourceLifecycle.virtualMachine")
            }, {
                id: 1,
                name: this.$t("resourceLifecycle.virtualNetwork")
            }, {
                id: 2,
                name: this.$t("resourceLifecycle.objectStorage")
            }, {
                id: 3,
                name: this.$t("resourceLifecycle.database")
            }, {
                id: 4,
                name: this.$t("resourceLifecycle.elasticIP")
            }, {
                id: 5,
                name: this.$t("resourceLifecycle.azureMySQLServer")
            }, {
                id: 6,
                name: this.$t("resourceLifecycle.azureMariaDBServer")
            }, {
                id: 7,
                name: this.$t("resourceLifecycle.azureRedisServer")
            }],
            addLoading: false,
            actionUrl: '',
            userName: getCookie(global.cookieName),
            attachmentIDs: [],
            cost:0,
            approvalFlowList: [],
            resourceApplicationForm: {
                resourceId: this.$route.query.id,
                accountId: '',
                region: '',
                usageNote: '',
                resourceName: '',
                resourceType: this.$route.query.lifecycleResourceType,
                accountTypeSearchKey: this.$route.query.platform,
                approvalFlow: '',
                describe: ''
            },
            ruleValidate: {
                approvalFlow: [
                    {required: true, message: this.$t("resourceLifecycle.inputValidation.requiredProcess"), trigger: 'change', type: 'number'}
                ],
                describe: [
                    {required: true, message: this.$t("resourceLifecycle.inputValidation.requiredResourceReturnOrRecycleReason"), trigger: 'change'}
                ]
            },
            columns: [
            {
                title: this.$t("resourceLifecycle.select"),
                key: 'id',
                width: 70,
                align: 'center',
                render: (h, params) => {
                    let id = params.row.id;
                    let flag = false;
                    let self = this
                    if (this.resourceApplicationForm.resourceId === id) {
                        flag = true
                    } else {
                        flag = false
                    }
                    return h('div', [
                        h('Radio', {
                            props: {
                                value: flag
                            },
                            on: {
                                'on-change': () => {
                                    self.resourceApplicationForm.resourceId = id;
                                    self.resourceApplicationForm.resourceType = params.row.lifecycleResourceType
                                    self.resourceApplicationForm.accountTypeSearchKey = params.row.platform
                                    self.resourceApplicationForm.accountId = params.row.accountId
                                    self.resourceApplicationForm.region = params.row.regionName
                                }
                            }
                        })
                    ])
                }
            },
            {
                title: this.$t("resourceLifecycle.use"),
                key: 'usageNote'
            },
            {
                title: this.$t("resourceLifecycle.platform"),
                key: 'platformString'
            },
            {
                title: this.$t("resourceLifecycle.region"),
                key: 'region'
            },
            {
                title: this.$t("resourceLifecycle.resourceName"),
                key: 'lifecycleResourceName'
            },
            {
                title: this.$t("resourceLifecycle.resourceType"),
                key: 'lifecycleResourceTypeDesc'
            },
            {
                title: this.$t("resourceLifecycle.environment"),
                key: 'environmentDesc'
            },
            {
                title: this.$t("resourceLifecycle.term"),
                key: 'duration'
            },
            {
                title: this.$t("resourceLifecycle.startDate"),
                key: 'startDateStr'
            },
            {
                title: this.$t("resourceLifecycle.endDate"),
                key: 'endDateStr'
            },
            {
                title: this.$t("resourceLifecycle.estimatedCost"),
                key: 'cost'
            }],
            lifecycleResourcesDate: []
        }
    },
    mounted: function () {
        // 上传附件接口
        this.actionUrl = process.env.API_ROOT + '/sme/file/uploadFileS3';
        this.selectListNames();
      //初始化参数
      if (this.$route.query.lifecycleResourceType != undefined) {
        this.searchLifecycleResourcesDate();
      }
    },
    watch: {
      cost: {
        handler(val) {
          this.changeCost(val);
        },
        immediate: true
      }
    },
    methods: {
        searchLifecycleResourcesDate: function () {
            this.$api.lifecycleResourceApplication.listLifecycleResource({
                "usageNote": this.resourceApplicationForm.usageNote,
                "lifecycleResourceName": this.resourceApplicationForm.resourceName,
                "lifecycleResourceType": this.resourceApplicationForm.resourceType
            })
            .then(res => {
                this.lifecycleResourcesDate = res.data;
            })
        },
        // 审批流
        selectListNames: function () {
            this.$api.processTemplate.selectListNames({
                "type": 10
            })
            .then(res => {
                this.approvalFlowList = res.data;
                if(this.approvalFlowList.length>0){
                    this.resourceApplicationForm.approvalFlow = this.approvalFlowList[0].id
                }
            })
        },
        /*********************附件*********************************/
        // 上传成功
        uploadSuccess(res, file, fileList) {
            this.$Message.success(this.$t("resourceLifecycle.response.uploadSuccess"));
            this.attachmentIDs.push(file.response.id);
            this.id = file.response.id;
        },
        // 上传失败
        uploadError(error, file) { //上传失败
            this.$Message.error(this.$t("resourceLifecycle.response.uploadFail"));
        },
        // 删除附件
        handleRemove(file, fileList) {
            this.$api.file.deleteAttatchment("id", file.response.id)
            .then(res => {
                this.$Message.success(this.$t("resourceLifecycle.response.deleteSuccess"));
                this.attachmentIDs = [];
                for (var i = 0; i < fileList.length; i++) {
                    this.attachmentIDs.push(fileList[i].response.id)
                }
            })
        },
        // 提交
        handleSubmit: function (name) {
            var submitLifecycleResourceDTO = {
                "oldLifecycleResourceId": this.resourceApplicationForm.resourceId,
                "processTemplateId": this.resourceApplicationForm.approvalFlow,
                "attachmentIDs": this.attachmentIDs,
                "remark": this.resourceApplicationForm.describe,
            };
            // 提交资源回收
            this.$api.lifecycleResourceApplication.submitLifecycleResourceRecycle(submitLifecycleResourceDTO)
            .then(res => {
                this.$Message.success(this.$t("resourceLifecycle.response.recycleSuccess"));
                this.$router.push({path: '/approvalTask', query: {t: Date.now()}});
            })
            .catch(error => {
                if (error.status == 500) {
                    setTimeout(() => {
                    }, 0)
                }
            })
        }
    }
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_recycle/ResourceBasicInformationSearch.vue